import styled from 'styled-components'

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.black};
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 0.5rem;

  .image {
    height: 400px;
    width: 400px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
    font-size: 1.5rem;

    svg {
      width: 2rem;
      height: 2rem;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  h4 {
    margin: 1.5rem 0;
    font-size: 1.5rem;

    &:first-child {
      margin-top: 0;
    }
  }

  .grouped {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
  }

  .field {
    flex-grow: 1;
    margin-bottom: 0.75rem;
  }

  label {
    font-size: 1.25rem;
    display: block;
    color: ${({ theme }) => theme.colors.white};
    margin-bottom: 0.5rem;
  }

  input:not(input[type='submit'], input[type='radio']),
  textarea,
  select {
    flex-grow: 1;
    background: ${({ theme }) => theme.colors.gray800};
    color: ${({ theme }) => theme.colors.white};
    border: 1px solid transparent;
    border-radius: 5px;
    transition: all 0.2s;
    height: 42px;
    width: 100%;
    margin: 0 0 0.5rem;
    padding: 0 0.7rem;
  }

  textarea {
    height: 200px;
    width: 100%;
    padding: 0.7rem;
    resize: none;
  }

  input[type='submit'],
  button[type='submit'] {
    background: ${({ theme }) => theme.colors.red};
    width: 100%;
    max-width: 16rem;
    min-height: 3.125rem;
    border: none;
    border-radius: 5px;
    font-weight: 700;
    font-size: 1.25rem;
    text-transform: uppercase;
    color: rgb(255, 255, 255);
    transition: background 0.3s ease 0s;
  }

  .error p {
    margin-top: -0.25rem;
    color: ${({ theme }) => theme.colors.red} !important;
  }

  .error input,
  .error select {
    border-color: ${({ theme }) => theme.colors.red} !important;
  }

  @media (max-width: 540px) {
    .grouped {
      flex-direction: column;
    }
  }
`
